import React, {Component} from 'react'

import {Checkbox, List, ListItem, Typography} from '@material-ui/core'

import PaperBlock from "../../../ui/PaperBlock"

/**
 * attachments - вложения.
 * selected - выбранные вложения.
 * checkboxes - показывать или нет чекбоксы {true/false}.
 * filter_shops - фильтрация по магазинам (список магазинов).
 * 
 * onClickAttachment(attachment)
 * onDoubleClickAttachment(attachment)
 * onCheckAttachmentClick(attachment)
 */

class AttachmentsList extends Component {

    render() {
        let attachments = this.props.attachments ? this.props.attachments : []
        
        // Фильтр по выбранным магазинам.
        if (this.props.filter_shops && this.props.filter_shops.length) {
            attachments = attachments.filter(attachment => {
                let shop = attachment.shop ? attachment.shop : {id: null}
                return this.props.filter_shops.find(s => s.id === shop.id)
            })
        }

        return <PaperBlock>
            <List>
                {attachments.map((attachment, key) => 
                    <ListItem 
                        style = {{display: "flex", gap: "10px", alignItems: "stretch"}}
                        key = {key}
                        button
                        selected = {this.props.selected ? this.props.selected["id"] === attachment["id"] : false}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onClickAttachment === "function") {
                                this.props.onClickAttachment(attachment)
                            }
                        }}
                        onDoubleClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onDoubleClickAttachment === "function") {
                                this.props.onDoubleClickAttachment(attachment)
                            }
                        }}
                    >
                        {
                            this.props.checkboxes ? 
                                <div 
                                    style={{
                                        flex: "0 0 50px",
                                        display: "flex",
                                        justifyContent: "center"
                                    }}
                                    onClick = {e => {
                                        e.stopPropagation()
                                        if (typeof this.props.onCheckAttachmentClick === "function") {
                                            this.props.onCheckAttachmentClick(attachment)
                                        }
                                    }}
                                    onDoubleClick={e => e.stopPropagation()}
                                >
                                    <Checkbox checked = {Boolean(attachment.checked)} />
                                </div>
                            :
                                undefined
                        }
                        <div style = {{flex: "1 1 auto"}}>
                            <Typography variant='h5'>{attachment.item.name}</Typography>
                            <Typography inline variant='subtitle1'>Магазин: </Typography>
                            {attachment.shop ? attachment.shop.name : <Typography inline variant='subtitle1' color = "textSecondary"> не указан </Typography>}
                        </div>
                        <Typography variant='subtitle1' style = {{flex: "0 0 50px", textAlign: "center"}}>{attachment.quantity}</Typography>
                    </ListItem>
                )}
            </List>
        </PaperBlock>
    }

}

export default AttachmentsList